<template>
  <a-drawer
    placement="right"
    width="500"
    :closable="false"
    :visible="visible"
    @close="onClose"
  >
    <div slot="title">
      <span>用户详情</span>
    </div>
    <div v-if="loading" style="text-align:center"><a-spin/></div>
    <div style="margin-left:15px" v-if="!loading">
      <detail-list size="small" :col="1">
        <detail-list-item term="账号信息">{{ viewDetailData.phone }}</detail-list-item>
        <detail-list-item term="昵称">{{ viewDetailData.nickname }}</detail-list-item>
        <detail-list-item term="注册时间">{{ viewDetailData.create_time }}</detail-list-item>
        <detail-list-item term="手机号码">{{ viewDetailData.phone }}</detail-list-item>
        <detail-list-item term="登录时间">{{ viewDetailData.last_login_time }}</detail-list-item>
      </detail-list>
    </div>
  </a-drawer>
</template>
<script>
import { getUserDetail } from '@/api/member'
import _ from 'lodash'
import { TcgTable } from '@/components'
import DetailList from '@/components/DescriptionList'
const DetailListItem = DetailList.Item
export default {
  components: {
    DetailListItem,
    DetailList,
    TcgTable
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    id: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      // 抽屉加载
      loading: true,
      viewDetailData: {}
    }
  },
  methods: {
    // 关闭抽屉
    onClose () {
      this.$emit('hide')
    },
    // 加载数据详情
    getDetail () {
      this.loading = true
      getUserDetail(this.id).then(res => {
        if (_.get(res, 'code') === 200) {
          this.viewDetailData = _.get(res, 'data', {})
          this.loading = false
        }
      })
    },
    // 提交筛选
    handleSubmit (e) {
      e.preventDefault()
      this.$refs.table.refresh(true)
    },
    openViewModal (record) {
      this.familyId = record.fid
      this.familyName = '家庭：' + record.name
      this.showFamily = true
    },
    handleOk () {
      this.showFamily = false
    }
  },
  created () {
    this.getDetail()
  }
}
</script>
